import { BigNum, ZERO } from '@drift-labs/sdk';
import ValueWithLabelCard from 'src/components/primitives/ValueWithLabelCard/ValueWithLabelCard';
import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import PortfolioStatsCardItem from 'src/components/PortfolioPage/PortfolioStatsCardItem';

interface Props {
	totalValue: BigNum | undefined;
	delegatedTotalValue: BigNum | undefined;
	mainPoolTotalValue: BigNum | undefined;
	isolatedPoolTotalValue: BigNum | undefined;
	vaultTotalValue: BigNum | undefined;
	nonDriftStakeTotalValue: BigNum | undefined;
	driftStakeTotalValue: BigNum | undefined;
}

export default function PortfolioAccountsStatsCard({
	totalValue,
	delegatedTotalValue,
	mainPoolTotalValue,
	isolatedPoolTotalValue,
	vaultTotalValue,
	nonDriftStakeTotalValue,
	driftStakeTotalValue,
}: Props) {
	return (
		<ValueWithLabelCard.Container className="sm:justify-between">
			<PortfolioStatsCardItem
				label={
					<Tooltip
						content={`This does not include values from Managed Accounts (${delegatedTotalValue?.toNotional()}).`}
						disabled={!delegatedTotalValue?.gt(ZERO)}
					>
						Total Value (All Accounts)
					</Tooltip>
				}
				value={totalValue}
				displayType="currency"
				isAccountValueToHide
			/>
			<PortfolioStatsCardItem
				label="Main Accounts"
				value={mainPoolTotalValue}
				displayType="currency"
				isAccountValueToHide
			/>
			<PortfolioStatsCardItem
				label="Isolated Pools"
				value={isolatedPoolTotalValue}
				displayType="currency"
				isAccountValueToHide
			/>
			<PortfolioStatsCardItem
				label="Strategy Vaults"
				value={vaultTotalValue}
				displayType="currency"
				isAccountValueToHide
			/>
			<PortfolioStatsCardItem
				label="Insurance Fund"
				value={nonDriftStakeTotalValue}
				displayType="currency"
				isAccountValueToHide
			/>
			<PortfolioStatsCardItem
				label="DRIFT Staking"
				value={driftStakeTotalValue}
				displayType="currency"
				isAccountValueToHide
			/>
		</ValueWithLabelCard.Container>
	);
}
